import EduNotCompleted from './EduNotCompleted';

export default EduNotCompleted;
